export default __webpack_public_path__ + "static/linkBg5-069ceb0e9b52d4c83a6fb59e2be29f9d.png";